/** Collect all sidebar link paths (without layout slug) for redirects. */
export function collectMenuPaths(menuGroups) {
  const paths = new Set();

  const visit = (item) => {
    if (item.path) {
      paths.add(item.path);
    }
    item.children?.forEach(visit);
  };

  menuGroups.forEach((group) => {
    group.Items?.forEach(visit);
  });

  return [...paths];
}
